import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const IconCircleContext = /*#__PURE__*/createContext(undefined);
export const IconCircleProvider = ({
  isLegacy,
  children
}) => {
  return /*#__PURE__*/_jsx(IconCircleContext.Provider, {
    value: {
      isLegacy
    },
    children: children
  });
};

/**
 * Provides the context for the `IconCircle` component.
 * Note: The context is only available when the `IconCircle` component is rendered as an ancestor.
 * @returns iconCircleContext - The context for the `IconCircle` component.
 * @returns iconCircleContext.isLegacy - Boolean indicating if the `IconCircle` component is in legacy mode.
 */
export const useIconCircleContext = () => {
  const iconCircleContext = useContext(IconCircleContext);
  return iconCircleContext;
};